import lscache from 'lscache';
import { ExperienceSource } from 'model/IExperience';

class RecentlyViewedExperiencesCache {
  public static LS_KEY = 'recently-viewed-experiences';

  private SIZE = 3;
  private data: ExperienceSource[] = [];

  constructor() {
    this.data = lscache.get(RecentlyViewedExperiencesCache.LS_KEY) ?? [];
  }

  store(experience: ExperienceSource) {
    if (!experience) return;
    this.data = [
      experience,
      ...this.data.filter(({ id }) => id !== experience.id),
    ].slice(0, this.SIZE);
    lscache.set(RecentlyViewedExperiencesCache.LS_KEY, this.data);
  }

  getAll() {
    return this.data;
  }
}

export { RecentlyViewedExperiencesCache };
export default new RecentlyViewedExperiencesCache();
